import { makeAuthedRequest } from "utils/makeAuthedRequest";
import { useQuery, useMutation, useQueryClient } from "react-query";
const oneDay = 24 * 60 * 60 * 1000; // 24 hours in milliseconds

export function useEmergencyContacts() {
  const queryClient = useQueryClient();

  const { data, status, isLoading, refetch } = useQuery(
    ["emergency-contacts"],
    () =>
      makeAuthedRequest("v1/settings/emergency-contacts", {
        method: "GET",
      }).then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const body = await res.json();
          throw new Error(body.message);
        }
      }),
    {
      refetchOnWindowFocus: false,
      staleTime: Infinity, // Adjust as needed
      cacheTime: Infinity, // Adjust as needed
    }
  );

  const createEmergencyContact = useMutation(
    (emergencyContactData) =>
      makeAuthedRequest(`v1/settings/emergency-contacts`, {
        method: "POST",
        body: JSON.stringify(emergencyContactData),
      }).then(async (res) => {
        if (res.ok) {
          return res;
        } else {
          const body = await res.json();
          throw new Error(body.message);
        }
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries("emergency-contacts");
      },
      onError: (err) => {
        console.error(err);
      },
      onSettled: () => {
        queryClient.refetchQueries("emergency-contacts");
      },
    }
  );

  const updateEmergencyContact = useMutation(
    ({ contactId, updateData }) =>
      // {
      // return (
      makeAuthedRequest(`v1/settings/emergency-contacts/${contactId}`, {
        method: "PUT",
        body: JSON.stringify(updateData),
      }).then(async (res) => {
        if (res.ok) {
          return res;
        } else {
          const body = await res.json();
          throw new Error(body.error);
        }
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries("emergency-contacts");
      },
      onError: (err) => {
        console.error(err);
      },
      onSettled: () => {
        queryClient.refetchQueries("emergency-contacts");
      },
    }
  );
  // });

  // const useDeleteEmergencyContact = () => {
  const deleteEmergencyContact = useMutation(
    (contactId) =>
      makeAuthedRequest(`v1/settings/emergency-contacts/${contactId}`, {
        method: "DELETE",
      }).then(async (res) => {
        if (res.ok) {
          return res;
        } else {
          const body = await res.json();
          throw new Error(body.error);
        }
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries("emergency-contacts");
      },
      onError: (err) => {
        console.error(err);
      },
    }
  );

  return {
    data,
    status,
    isLoading,
    refetch,
    createEmergencyContact,
    updateEmergencyContact,
    deleteEmergencyContact,
  };
}
